/**
 * Rainbow Blocked Action Types
 */

export const RAINBOW_BLOCKED_ACTION_ID = 'dungeo.rainbow.blocked';

export const RainbowBlockedMessages = {
  BLOCKED: 'dungeo.rainbow.blocked'
} as const;
